import { LitElement, html, css } from 'lit-element';
import { FBP } from '@furo/fbp';
import '@furo/layout/src/furo-vertical-scroller';
import '@furo/input/src/furo-icon-button.js';
import '@furo/data/src/furo-deep-link.js';
import '@furo/app/src/furo-loading-indicator-bar.js';

import './asg-list-item.js';

/**
 * `ausgaben-list`
 * Describe your element
 *
 * @summary shortdescription
 * @customElement
 * @demo demo/ausgaben-list.html
 * @appliesMixin FBP
 */
class AsgList extends FBP(LitElement) {
  constructor() {
    super();

    this._FBPAddWireHook('--collectionResponse', e => {
      if (typeof e.data === 'undefined') {
        this.titel = '';
      } else {
        this.titel = e.data[0].data.display_supportcase;
      }
      this.requestUpdate();
    });
  }

  /**
   * flow is ready lifecycle method
   */
  _FBPReady() {
    super._FBPReady();
    // this._FBPTraceWires()
  }

  /**
   *
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return css`
      :host {
        display: block;
        height: 100%;
        width: var(--kachel-breite);
        padding: 24px 0;
        background-color: var(--surface, white);
        box-sizing: border-box;
      }

      .date {
        border-top: 1px solid gainsboro;
        position: sticky;
        top: 0;
        background-color: whitesmoke;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 12px;
        z-index: 1;
      }

      .date span {
        float: right;
      }

      furo-icon-button {
        background-color: var(--primary);
        border-radius: 50%;
        color: var(--on-primary);
        margin: 12px;
      }

      .sc {
        color: var(--primary);
        line-height: 64px;
        font-size: 20px;
        text-align: center;
      }

      asg-list-item[selected] {
        background-color: rgba(26, 127, 240, 0.18);
      }
    `;
  }

  /**
   * Exposes --reload-list
   * @param {*} det
   */
  reloadList(det) {
    this._FBPTriggerWire('--reload-list', det);
  }

  setQp(qp) {
    this._FBPTriggerWire('--qpIn', qp);
  }

  /**
   * @private
   * @returns {TemplateResult}
   */
  render() {
    // language=HTML
    return html`
      <furo-vertical-flex>
        <furo-horizontal-flex>
          <div flex></div>
          <furo-icon-button
            class="primary"
            icon="add"
            @-click="^^add-time-clicked(injectedHTS),--addClicked"
          ></furo-icon-button>
        </furo-horizontal-flex>
        <zerf-dateselector @-date-changed="--date-selected, ^^date-selected"></zerf-dateselector>
        <furo-vertical-scroller flex @-list-item-clicked="--itemSelected">
          <furo-loading-indicator-bar
            ƒ-start="--htsInjected, --reload-list"
            ƒ-stop="--collectionResponse"
          ></furo-loading-indicator-bar>
          <template
            is="flow-repeat"
            ƒ-inject-items="--collectionResponse(*.entities)"
            ƒ-select="--itemSelected"
            ƒ-deselect="--addClicked"
          >
            <asg-list-item
              ƒ-inject="--item"
              ƒ-select="--itemSelected"
              ƒ-deselect="--itemDeSelected"
              ƒ-clear-date="--firstItem"
              ƒ-.index="--index"
            ></asg-list-item>
          </template>
        </furo-vertical-scroller>
      </furo-vertical-flex>

      <furo-deep-link
        service="Ausgabe"
        ƒ-qp-in="--qpIn"
        @-hts-out="--hts,((injectedHTS))"
      ></furo-deep-link>
      <furo-collection-agent
        service="Ausgabe"
        ƒ-hts-in="--hts"
        @-hts-injected="--htsInjected"
        ƒ-update-qp="--date-selected"
        @-qp-changed="--reload-list"
        ƒ-list="--htsInjected, --reload-list"
        @-response="--collectionResponse"
      ></furo-collection-agent>
    `;
  }
}

window.customElements.define('asg-list', AsgList);
